import { ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { theme } from '../../config/theme/theme';
import { ErrorBoundary } from '../controllers/ErrorBoundary';

/**
 * Modals are rendered outside the context of <App /> and do not
 * inherit its providers.
 * Use this HOC to pass any context or property required by modals.
 */
export const withModalProviders = (Component: any) => {
  const Wrapper = (props: any) => {
    return (
      <ErrorBoundary>
        <BrowserRouter future={{ v7_relativeSplatPath: false, v7_startTransition: false }}>
          <ThemeProvider theme={theme}>
            <Component {...props} />
          </ThemeProvider>
        </BrowserRouter>
      </ErrorBoundary>
    );
  };
  return Wrapper;
};
